export default __webpack_public_path__ + "static/media/signin.33e4983a.svg";